import React from "react";
import PropTypes from "prop-types";
import "./ActionButton.css"; // Import the CSS file for button styling

const ActionButton = ({ label, onClick, dataAction }) => {
  return (
    <button
      className="action-button-comp"
      data-action={dataAction}
      onClick={(e) => {
        console.log("[ActionButton] Continue clicked");
        onClick(e); // keep existing behaviour
      }}
    >
      {label}
    </button>
  );
};

// Define prop types for the component
ActionButton.propTypes = {
  label: PropTypes.string.isRequired, // The button label (text)
  onClick: PropTypes.func.isRequired, // The function to execute when clicked
  dataAction: PropTypes.string, // Optional data-action attribute for styling
};

export default ActionButton;
